import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🌅',
    title: 'pages.onboarding.freeTimeQuestion.answer1',
    subtitle: 'pages.onboarding.freeTimeQuestion.answer1Subtitle',
  },

  {
    emoji: '☀️',
    title: 'pages.onboarding.freeTimeQuestion.answer2',
    subtitle: 'pages.onboarding.freeTimeQuestion.answer2Subtitle',
  },

  {
    emoji: '🌤️',
    title: 'pages.onboarding.freeTimeQuestion.answer3',
    subtitle: 'pages.onboarding.freeTimeQuestion.answer3Subtitle',
  },
  {
    emoji: '🌆',
    title: 'pages.onboarding.freeTimeQuestion.answer4',
    subtitle: 'pages.onboarding.freeTimeQuestion.answer4Subtitle',
  },
  {
    emoji: '🌙',
    title: 'pages.onboarding.freeTimeQuestion.answer5',
    subtitle: 'pages.onboarding.freeTimeQuestion.answer5Subtitle',
  },
]

export default function FreeTimeQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.freeTimeQuestion.title"
    />
  )
}
